'use strict';

const React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    const n = Object.create(null, { [Symbol.toStringTag]: { value: 'Module' } });
    if (e) {
        for (const k in e) {
            if (k !== 'default') {
                const d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: () => e[k]
                });
            }
        }
    }
    n.default = e;
    return Object.freeze(n);
}

const React__namespace = /*#__PURE__*/_interopNamespace(React);

const SvgNavIntegrationsFill = (props) => React__namespace.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React__namespace.createElement("path", { fill: "#2D2E2E", d: "M16.21 1.5H7.79L6.53 3H2v18h20V3h-4.53l-1.26-1.5ZM18.35 12l-2.52 3h-2.61l2.52-3-2.52-3h2.61l2.52 3Zm-7.57-3-2.52 3 2.52 3H8.17l-2.52-3 2.52-3h2.61Z" })
);

module.exports = SvgNavIntegrationsFill;
//# sourceMappingURL=NavIntegrationsFill.cjs.js.map
